import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  stepper: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    width: '100%',
  },
  step: {
    display: 'flex',
    gap: 12,
    alignItems: 'stretch',
    width: '100%',
  },
  rail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    width: 24,
  },
  node: {
    boxSizing: 'border-box',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    flexShrink: 0,
    '& svg': { fontSize: 12 },
  },
  completed: {
    backgroundColor: C.successText,
    '& svg': { color: C.cardBg },
  },
  current: {
    backgroundColor: C.stepCurrent,
    '& svg': { color: C.cardBg },
  },
  upcoming: {
    backgroundColor: C.cardBg,
    border: `1px solid ${C.stepUpcomingBorder}`,
    '& svg': { color: C.mutedText },
  },
  line: {
    flex: '1 0 0',
    minHeight: 16,
    width: 1,
    backgroundColor: C.separator,
  },
  lineComplete: {
    backgroundColor: C.successText,
  },
  content: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    paddingBottom: 12,
  },
  stageName: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.darkText,
  },
  stageTime: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: C.mutedText,
  },
  empty: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: C.mutedText,
    margin: 0,
  },
}))
